@if (gameTable) {
<div class="event-table-card event-table-card-clickable border rounded-3 p-3 mb-2" tabindex="0"
  [attr.aria-label]="'Apri dettaglio del tavolo ' + gameTable.tableName" (click)="onCardClick($event)"
  (keydown)="onCardKeydown($event)">
  <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 gap-sm-3">
    <div class="event-table-info flex-grow-1 w-100">
      <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
        <h5 class="event-table-name fw-bold mb-0 text-break">{{ gameTable.tableName }}</h5>
        <span class="badge rounded-pill align-middle flex-shrink-0" style="font-size: 0.65rem;"
              [ngClass]="getPegiBadgeClass(gameTable.minAge ?? gameTable.playedGame.minAge)">
          {{ (gameTable.minAge ?? gameTable.playedGame.minAge) ? 'PEGI ' + (gameTable.minAge ?? gameTable.playedGame.minAge) : 'PEGI 12' }}
        </span>
      </div>
      <p class="event-table-game mb-1 text-secondary fw-semibold text-break">{{ gameTable.playedGame.gameName }}</p>
      @if (gameTable.gameMasterName) {
      <p class="event-table-master small text-muted mb-0">
        <i class="bi bi-person-fill me-1"></i>Master: {{ gameTable.gameMasterName }}
      </p>
      }
    </div>
    <div class="event-table-status flex-shrink-0 text-start text-sm-end mt-1 mt-sm-0 align-self-start align-self-sm-center">
      @if (isTableFull()) {
      <span class="badge p-2 text-uppercase fw-bold text-white" style="background-color: #8b0000 !important;">Completo</span>
      } @else {
      <span class="badge bg-success p-2 text-uppercase fw-bold">Posti Disponibili</span>
      <div class="small fw-bold text-success mt-1 text-center">{{ getAcceptedPlayerCount() }}/{{ gameTable.maxPlayers }}</div>
      }
    </div>
  </div>
</div>
}
